import { useEventRefresher as r } from "@zdrbm/zdr-react";
import { useBoxState as o } from "./index.es523.js";
function n() {
  const e = o();
  return r(e == null ? void 0 : e.hovered), (e == null ? void 0 : e.hovered.get()) ?? !1;
}
export {
  n as useBoxIsHovered
};
//# sourceMappingURL=index.es522.js.map
